import React, { createContext, useState } from "react";
const DashboardContext = createContext({})
export { DashboardContext }
export default DashboardContext